import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

function MySales() {
    const [people, setPeople] = useState([])
    const [msg, setMsg] = useState("")
      
  
    useEffect(() => {
      axios.get("https://dealersonly.parts/beta/api/user/orders?type=received")
      .then(res => {
        setPeople(res.data)
      })
      .catch((error) => {
        console.log(error);
      })
  }, [])

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  
  
  
    const formatter = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    });
  
  return (
    <div className="px-4 lg:px-0">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">Verkaufte Artikel</h1>
          <p className="mt-2 text-sm text-gray-700">
            Eine Liste aller verkauften Artikel.
          </p>
        </div>
        
      </div>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Artikel
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Käufer
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Status
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Preis
                    </th>
                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                      <span className="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                {people?.length !== 0 && 
                  people?.reverse().map((person) => {

                    const dateObject = new Date(parseInt(person.orderDate))
  const date = dateObject.toLocaleString("de-DE", {timeZone: 'Europe/Berlin', day:"numeric", month: "long", year:"numeric"}) + " um " + dateObject.toLocaleString("de-DE", {timeZone: 'Europe/Berlin', hour:"numeric", minute: "numeric"})

                    return(
                    <tr key={person._id}>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                        <div className="flex items-center">
                          <div className="h-10 w-10 flex-shrink-0">
                            <img className="h-10 w-10 rounded-full" src={"https://dealersonly.parts/beta/app/files/DopePlaceholder.png"} alt="" />
                          </div>
                          <div className="ml-4">
                            <div className="font-medium text-gray-900">{person.artikel}</div>
                            <div className="text-gray-500">{date}</div>
                          </div>
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <div className="text-gray-900">{person.customer}</div>
                        <div className="text-gray-500">{person.email}</div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      {person.status ? <span className="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                          Versendet
                        </span> : <span className="inline-flex rounded-full bg-red-100 px-2 text-xs font-semibold leading-5 text-red-800">
                          Ausstehend
                        </span>}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{formatter.format(person.gesamt)}</td>
                      <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                        <Link to={`details/${person._id}`} className="text-indigo-600 hover:text-indigo-900">
                          Ansehen
                        </Link>
                      </td>
                    </tr>)
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MySales